import { render, staticRenderFns } from "./Ussd.vue?vue&type=template&id=2b53c538&"
import script from "./Ussd.vue?vue&type=script&lang=js&"
export * from "./Ussd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports